import styled from '@emotion/styled';
import { motion } from 'framer-motion';

export const AttachmentPreviewOverlay = styled(motion.div, {
  shouldForwardProp: (prop) => prop !== 'keyboardBottom',
})<{ keyboardBottom?: number }>`
  position: fixed;
  inset: 0;
  @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1005;
  padding: 16px;
  padding-bottom: ${(p) => 16 + (p.keyboardBottom ?? 0)}px;
  overscroll-behavior: none;
  touch-action: none;
  transition: padding-bottom 0.28s cubic-bezier(0.25, 0.1, 0.25, 1);
`;

export const AttachmentPreviewModalContent = styled(motion.div)`
  width: 343px;
  max-height: 540px;
  min-height: 260px;
  padding: 16px;
  background: #23252a;
  box-shadow: 0px 16px 40px rgba(0, 0, 0, 0.45);
  border-radius: 16px;
  outline: 1px #2b2d33 solid;
  outline-offset: -1px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: inline-flex;
`;

export const AttachmentWrapper = styled.div`
  max-height: 150px;
  align-self: stretch;
  flex-direction: column;
  gap: 6px;
  display: inline-flex;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

export const AttachmentItem = styled.div`
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 12px;
  background: #1e1f22;
  border-radius: 10px;
  outline: 1px #2b2d33 solid;
  outline-offset: -1px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  display: inline-flex;
  max-width: 100%;
`;

export const AttachmentIconAndLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  overflow: hidden;
`;

export const AttachmentLabel = styled.span`
  color: rgba(233, 236, 245, 0.9);
  font-size: 14px;
  font-family:
    Inter,
    system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    sans-serif;
  font-weight: 400;
  line-height: 19.6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AttachmentContext = styled.textarea`
  align-self: stretch;
  min-height: 44px;
  padding: 12px;
  background: #1e1f22;
  border-radius: 12px;
  outline: 1px rgba(0, 0, 0, 0) solid;
  outline-offset: -1px;
  color: #b7bdcb;
  font-size: 14px;
  font-family:
    Inter,
    system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    sans-serif;
  font-weight: 400;
  line-height: 19.6px;
  word-wrap: break-word;
  border: none;

  &:focus-visible {
    outline: 1px #2b2d33 solid;
    outline-offset: -1px;
  }
`;

export const ButtonsWrapper = styled.div`
  margin-top: 20px;
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const AddMoreFilesButton = styled.button`
  color: #5E84ED;
  font-size: 15px;
  font-family: Inter;
  font-weight: 600;
  line-height: 21px;
  word-wrap: break-word;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
`;